(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9922],{

/***/ 39057:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suspend",
      function () {
        return __webpack_require__(46885);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_suspend; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./images/suspend.png
/* harmony default export */ var suspend = ({"src":"/_next/static/media/suspend.3f2f6670.png","height":429,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA20lEQVR42mPo+3ic8efJiWwMQPBvNUPZv+0xvX///9f6f/8wFwMy+F/CIPV/b97Xf4cb//+6cuL/lzWrDMAS9z/cbn737/uZNy8v3P11ZfX//+fn/v+9VOVOEAMDK1jB+TeXZz3/+PT/9UdH/n8/1vrv//EJ/39vj/7z5/pm3////7ODFb1YbrDmwyqT/783+Xy7e/78v8u3Xv8/df7x/80HHswBK3g21UTsxYpkbSBP+uiJO7tOXnr+f9X2G/9bZ56ey3DxQAsjAzKIXykbU7DYsKh5rX5MyQppAJiSehLzHFeBAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./pages/suspend.tsx






var Suspend = function(param) {
    var dbName = param.dbName;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "SuspendMain",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "SuspendBody container p-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Suspend",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "SuspendImage",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: 480,
                                height: 429,
                                src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(suspend === null || suspend === void 0 ? void 0 : suspend.src)),
                                alt: "Suspend Image"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        children: [
                            dbName,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "is no longer available"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "This website has been archived or suspended in accordance with our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://www.zegashop.com/web/terms-of-service/",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Terms Of Service."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        children: [
                            "For more information, Please,",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://www.zegashop.com/web/contact-us/",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: "_blank",
                                    children: "Contact us."
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_suspend = (Suspend);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,9774,2888,179], function() { return __webpack_exec__(39057); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);